import "./IdleTimeoutBar.css";

const PULSE_CYCLE_MS = 500;

/**
 * A thin bar stuck to the bottom of the viewport that slides from full width to nothing over
 * `timeoutMs` — how long until {@link useIdleReturn} bounces back to attract mode. Remount this
 * (e.g. via `key={resetCount}`) whenever the idle timer restarts so the animation restarts too.
 */
export function IdleTimeoutBar(props: { timeoutMs: number; pulseMs: number }): React.JSX.Element {
  const { timeoutMs, pulseMs } = props;
  const pulseDelayMs = Math.max(0, timeoutMs - pulseMs);
  const pulseIterations = Math.max(1, Math.ceil(pulseMs / PULSE_CYCLE_MS));

  return (
    <div className="idle-timeout-bar">
      <div
        className="idle-timeout-bar__fill"
        style={{
          animationDuration: `${timeoutMs}ms, ${PULSE_CYCLE_MS}ms`,
          animationDelay: `0ms, ${pulseDelayMs}ms`,
          animationIterationCount: `1, ${pulseIterations}`,
        }}
      />
    </div>
  );
}
